import { Text } from './styles';
import { PlanProps } from './types';

export function Plan({ code, name }: Readonly<PlanProps>) {
  return <Text>{`${code ?? ''} - ${name ?? ''}`}</Text>;
}
